var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4267B2;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C2191E;}\r\n\t.st4{fill:#1DA1F3;}\r\n\t.st5{fill:#FEFE00;}\r\n\t.st6{fill:#25D366;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st7{fill:#CB2027;}\r\n\t.st8{fill:#0077B5;}\r\n\t.st9{fill:url(#SVGID_2_);}\r\n\t.st10{fill:url(#SVGID_3_);}\r\n\t.st11{fill:#FF004F;}\r\n\t.st12{fill:#00F7EF;}\r\n\t.st13{fill:#5181B8;}\r\n\t.st14{fill:#395976;}\r\n\t.st15{fill:#F58220;}\r\n\t.st16{fill:#E6162D;}\r\n\t.st17{fill:#FF9933;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guidlines"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M58,19.4v9.3c-0.5,0-1.1,0.1-1.7,0.1c-4.5,0-8.7-1.7-11.9-4.4v19.8c0,4-1.3,7.8-3.6,10.8     c-3.2,4.3-8.4,7.2-14.3,7.2c-6.4,0-12-3.4-15.1-8.4c3.2,3,7.5,4.9,12.2,4.9c5.8,0,11-2.8,14.2-7.2c2.2-3,3.6-6.7,3.6-10.8V20.8     c3.2,2.8,7.3,4.4,11.9,4.4c0.6,0,1.1,0,1.7-0.1v-6c0.9,0.2,1.7,0.3,2.6,0.3H58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M29,26.3v10.3c-0.7-0.2-1.5-0.3-2.2-0.3c-4.4,0-8,3.7-8,8.2c0,1,0.2,1.9,0.5,2.8c-2-1.5-3.4-3.9-3.4-6.6     c0-4.5,3.6-8.2,8-8.2c0.8,0,1.5,0.1,2.2,0.3l0-6.6c0.2,0,0.4,0,0.6,0C27.5,26.2,28.3,26.2,29,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.9,12c-1.8-1.6-3.1-3.8-3.8-6.1h2.4c0,0.5,0,0.9,0,1.4C44.7,8.9,45.2,10.5,45.9,12z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,19.2v6c-0.5,0.1-1.1,0.1-1.7,0.1c-4.5,0-8.7-1.7-11.9-4.4v19.8c0,4-1.3,7.8-3.6,10.8c-3.3,4.4-8.4,7.2-14.2,7.2   c-4.7,0-9-1.9-12.2-4.9c-1.7-2.8-2.7-6-2.7-9.5c0-9.7,7.7-17.6,17.3-17.9l0,6.6c-0.7-0.2-1.5-0.3-2.2-0.3c-4.4,0-8,3.7-8,8.2   c0,2.7,1.3,5.2,3.4,6.6c1.1,3.1,4.1,5.4,7.5,5.4c4.4,0,8-3.7,8-8.2V5.9h7.3c0.7,2.4,2,4.5,3.8,6.1C47.7,15.6,51.1,18.3,55.1,19.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M26.1,22.8l0,3.4c-9.6,0.3-17.3,8.2-17.3,17.9c0,3.5,1,6.7,2.7,9.5C8.1,50.3,6,45.7,6,40.5      c0-9.9,8-17.9,17.8-17.9C24.6,22.6,25.4,22.7,26.1,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M42.1,5.9h-7.3v38.6c0,4.5-3.6,8.2-8,8.2c-3.5,0-6.4-2.2-7.5-5.4c1.3,0.9,2.9,1.5,4.6,1.5      c4.4,0,8-3.6,8-8.1V2h9.7v0.2c0,0.4,0,0.8,0.1,1.2C41.7,4.2,41.9,5.1,42.1,5.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M55.1,15.5C55.1,15.5,55.1,15.5,55.1,15.5v3.6c-4-0.8-7.4-3.5-9.3-7.1C48.3,14.3,51.5,15.6,55.1,15.5z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.4eb3c45ba88c3af5615d0c1f33b1ae8d.svg";
export { ForwardRef as ReactComponent };